export const DOWNLOAD_AUDIO_CLICKED = 'DOWNLOAD_AUDIO_CLICKED';
export const DOWNLOAD_SUCCEEDED = 'DOWNLOAD_SUCCEEDED';
export const DOWNLOAD_BLOCKED = 'DOWNLOAD_BLOCKED';
export const EMBED_CODE_CLICKED = 'EMBED_CODE_CLICKED';
export const SHARE_CLICKED = 'SHARE_CLICKED';
export const PUBLISH_PLAYER_CLICKED = 'PUBLISH_PLAYER_CLICKED';
export const CREATE_AUDIO_USECASE_SELECTED = 'CREATE_AUDIO_USECASE_SELECTED';
export const ERROR_OCCURRED = 'ERROR_OCCURRED';
export const DASHBOARD_TOOL_CLICKED = 'DASHBOARD_TOOL_CLICKED';
export const AUDIO_QUALITY_RATED = 'AUDIO_QUALITY_RATED';
